import * as React from "react";

import { ICandyApiDraftClient } from "../../../Common/CandyApiClient/ICandyApiClient";

import { useFormObject } from "./FormObjectProvider";
import { createHocDisplayName } from "./TypingUtils";

interface WithCandyApiClientInjectableProps {
    candyApiDraftClient: ICandyApiDraftClient;
}

export function withCandyApiDraftClient<P extends WithCandyApiClientInjectableProps>(
    WrappedComponent: React.ComponentType<P>
): React.ComponentType<Omit<P, "candyApiDraftClient">> {
    function WithCandyApiClient(props: Omit<P, "candyApiDraftClient">): JSX.Element {
        const form = useFormObject();

        // @ts-ignore Баг с HOC-ами https://github.com/Microsoft/TypeScript/issues/28938
        const newProps: P = {
            ...props,
            candyApiDraftClient: form.candyApiDraftClient,
        };

        return <WrappedComponent {...newProps} />;
    }
    WithCandyApiClient.displayName = createHocDisplayName(WrappedComponent, "CandyApiClient");
    return WithCandyApiClient;
}
